import { CANCEL_SUBSCRIPTION } from './actionTypes'

export default () => ({
  type: CANCEL_SUBSCRIPTION,
  payload: {

  }
})